import { DotsThree } from "@phosphor-icons/react"
import { IconButton } from "@tokenterminal/core/ui/button/IconButton"
import { SelectField } from "@tokenterminal/core/ui/input/SelectField"
import { type SetStateAction, type Dispatch } from "react"
import { type SelectedColumnItem } from "../SelectedColumnsList"

const uppercaseFirstLetter = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export const ColumnSettingsDropdown = ({
  item,
  index,
  setDraftSelectedColumns,
  selectedItems,
}: {
  item: SelectedColumnItem
  index: number
  setDraftSelectedColumns: Dispatch<SetStateAction<string[]>>
  selectedItems: SelectedColumnItem[]
}) => {
  return (
    <div className="flex flex-col gap-2">
      <SelectField
        aria-label="Column settings"
        trigger={({ selectValue }) => (
          <IconButton
            icon={DotsThree}
            iconProps={{
              weight: "bold",
            }}
            variant="ghost"
            size="small"
            label="Settings"
            className="!w-7 !h-7 text-fg-secondary"
          />
        )}
        selectedKey={item.field}
        onSelectionChange={(value) => {
          setDraftSelectedColumns((prev) => {
            return prev.map((c, i) => {
              if (i === index) {
                return value
              }
              return c
            })
          })
        }}
        buttonProps={{
          size: "xsmall",
        }}
        popoverProps={{
          placement: "bottom end",
        }}
      >
        {item.children.map((child) => (
          <SelectField.Option
            id={child.field || ""}
            key={child.field || ""}
            isDisabled={selectedItems.some(
              (item) =>
                item.field === child.field || item.parent === child.field
            )}
          >
            {uppercaseFirstLetter(child.header_name || "")}
          </SelectField.Option>
        ))}
      </SelectField>
    </div>
  )
}
